
const MyDNVNavigationCards = (props) => {

    const contentCards = props.configuration.contentCards;

    return (
        <div className="mydnv-cards-container">
            {contentCards.map(card => {
                return (
                    <div className="content-card" key={card.title}>
                        <div>
                            <h2 className="title" >{card.title}</h2>
                            <div className="description">{card.description}</div>
                        </div>
                        <div className="url"> { (!card.URL || card.URL == "") ? (<span className="coming-soon">{card.URLText}</span>) : (<a href={card.URL}>{card.URLText}</a>) }</div>
                    </div>
                )
            })}
    
        </div>

)
}

export { MyDNVNavigationCards };